<template>
  <v-row justify="center" align="start">
    <v-col cols="12" lg="12" md="12" xs="12">
      <v-banner icon="description">
        Product Overview
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact :to="{name: 'OrdersSearch'}">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col v-if="compProduct" cols="12" lg="3" md="12" xs="3">
      {{/*We force re-rendering because img gets stuck if error been thrown before*/}}
      <ProductImage :product="compProduct" :key="$route.fullPath"></ProductImage>
    </v-col>
    <v-col v-if="compProduct" cols="12" md="9" xs="12">
      <v-row justify="start" align="start">
        <v-col cols="12" xs="12" class="pt-0">
          <ProductName :product="compProduct"></ProductName>
        </v-col>
        <ProductLongDescription :product="compProduct"></ProductLongDescription>
        <v-col cols="12" xs="12">
          <PriceSelect :product="compProduct" :isBasketItem="false"></PriceSelect>
        </v-col>
        <v-col cols="12" xs="12">
          <product-info viewName = "search"/>
        </v-col>
        
      </v-row>
    </v-col>
    <v-col v-else cols="12" xs="12">Could not find product {{this.$attrs.id}}</v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

import ProductInfo from "@/components/order/ProductInfo.vue";
import ProductImage from "@/components/product/ProductImage.vue";
import ProductName from "@/components/product/ProductName.vue";
import PriceSelect from "@/components/product/PriceSelect.vue";
import ProductLongDescription from "@/components/product/ProductLongDescription.vue";

export default {
  components: {
    ProductImage,
    ProductName,
    PriceSelect,
    ProductLongDescription,
    ProductInfo
  },
  props: {
    product: null
  },

  data: () => {
    return {
      compProduct: null
    };
  },

  async activated() {
    console.log("-- Checking Product");
    console.log(this.product);
    if (this.product == undefined) {
      //We don't have our product passed to us already
      // -- So we're going to look it up using the ID from the URL (this.$attrs.id)
      await this.productSearch();
      console.log("-- Finished Loading Products");
    } else {
      this.compProduct = this.product;
    }
  },




  methods: {
    ...mapActions(["setSnackbar"]),
   

    async productSearch() {
      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        search: this.$attrs.id,
        orderDate: this.$store.getters.retrieveCurrentTrolly.order_date
      });

      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("product-search", params)
        .then(response => {
          this.loadingSearch = false;

          if (response.data.success) {
            console.log("-- Successful response");

            if (response.data.prods.length > 0) {
              this.compProduct = response.data.prods[0];
              console.log(this.compProduct);
            } else {
              this.setSnackbar({
                color: "error",
                text: "Could not find this product"
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="sass" scoped>
</style>